/**
 * iMed — header/menu interactions.
 * - Mobile nav drawer (#imed-mobile-nav) open/close
 * - Mobile nav disclosure toggles (sub-category lists)
 * - Desktop mega-menu click/touch fallback (CSS handles :hover already)
 * Vanilla JS, no dependencies, defensive null-checks (loads on every page).
 */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initMobileNavDrawer() {
    var drawer = qs('#imed-mobile-nav');
    if (!drawer) return;

    var openBtns = qsa('[data-mobile-nav-open]');
    var closeBtns = qsa('[data-mobile-nav-close]');
    var overlay = qs('[data-mobile-nav-overlay]', drawer);

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('imed-drawer-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('imed-drawer-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    qsa('[data-mobile-nav-toggle]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.imed-mobile-nav__item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initDesktopMegaMenu() {
    var items = qsa('.imed-nav__item--has-children');
    if (!items.length) return;

    var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    items.forEach(function (item) {
      var link = qs('.imed-nav__link', item);
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (hoverCapable) return; // desktop pointer devices rely on CSS :hover
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          items.forEach(function (i) { i.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
      });
    });

    document.addEventListener('click', function (e) {
      items.forEach(function (item) {
        if (!item.contains(e.target)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        items.forEach(function (item) { item.classList.remove('is-open'); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNavDrawer();
    initDesktopMegaMenu();
  });
})();
